__turbopack_context__.v({
  "button": "auth-module__Fkp83a__button",
  "error": "auth-module__Fkp83a__error",
  "eyebrow": "auth-module__Fkp83a__eyebrow",
  "field": "auth-module__Fkp83a__field",
  "form": "auth-module__Fkp83a__form",
  "input": "auth-module__Fkp83a__input",
  "lead": "auth-module__Fkp83a__lead",
  "note": "auth-module__Fkp83a__note",
  "page": "auth-module__Fkp83a__page",
  "panel": "auth-module__Fkp83a__panel",
  "secondaryButton": "auth-module__Fkp83a__secondaryButton",
  "switchRow": "auth-module__Fkp83a__switchRow",
  "title": "auth-module__Fkp83a__title",
});
